/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  TransferWindowsControllerListTransferWindowsV1200,
  TransferWindowsControllerListTransferWindowsV1Params
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTransferWindowsControllerListTransferWindowsV1Url = (params?: TransferWindowsControllerListTransferWindowsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/transfer-windows?${stringifiedParams}` : `/v1/transfer-windows`
}

/**
 * Chronological by default. Each row carries its league — crest included — and how many of your clubs sit in that league.
 * @summary List transfer windows (paginated, searchable, orderable, filterable by status)
 */
export const transferWindowsControllerListTransferWindowsV1 = async (params?: TransferWindowsControllerListTransferWindowsV1Params, options?: RequestInit): Promise<TransferWindowsControllerListTransferWindowsV1200> => {

  return apiRequest<TransferWindowsControllerListTransferWindowsV1200>(getTransferWindowsControllerListTransferWindowsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTransferWindowsControllerListTransferWindowsV1QueryKey = (params?: TransferWindowsControllerListTransferWindowsV1Params,) => {
    return [
    `/v1/transfer-windows`, ...(params ? [params] : [])
    ] as const;
    }


export const getTransferWindowsControllerListTransferWindowsV1QueryOptions = <TData = Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError = unknown>(params?: TransferWindowsControllerListTransferWindowsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTransferWindowsControllerListTransferWindowsV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>> = ({ signal }) => transferWindowsControllerListTransferWindowsV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TransferWindowsControllerListTransferWindowsV1QueryResult = NonNullable<Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>>
export type TransferWindowsControllerListTransferWindowsV1QueryError = unknown


export function useTransferWindowsControllerListTransferWindowsV1<TData = Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError = unknown>(
 params: undefined |  TransferWindowsControllerListTransferWindowsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>,
          TError,
          Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTransferWindowsControllerListTransferWindowsV1<TData = Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError = unknown>(
 params?: TransferWindowsControllerListTransferWindowsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>,
          TError,
          Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTransferWindowsControllerListTransferWindowsV1<TData = Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError = unknown>(
 params?: TransferWindowsControllerListTransferWindowsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List transfer windows (paginated, searchable, orderable, filterable by status)
 */

export function useTransferWindowsControllerListTransferWindowsV1<TData = Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError = unknown>(
 params?: TransferWindowsControllerListTransferWindowsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof transferWindowsControllerListTransferWindowsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTransferWindowsControllerListTransferWindowsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






